export enum FeatureFlag {
  ClearAcfStatus = 'clearAcfStatus',
  ConnectionStatusAccuracyUI = 'connectionStatusAccuracyUI',
  DashboardConnectionsV2 = 'dashboardConnectionsV2',
  DashboardApiExplorer = 'dashboardApiExplorer',
  DashboardConnectionDisconnect = 'dashboardConnectionDisconnect',
  DashboardSsoSelfService = 'dashboardSsoSelfService',
  PayStatementReverseMapping = 'payStatementReverseMapping',
  ReliusPayGroupMapping = 'reliusPayGroupMapping',
  DashboardCommandMenu = 'dashboardCommandMenu',
  PensionProWebinar = 'pensionProWebinar',
  DashboardConnectionsV2ProductsField = 'dashboardConnectionsV2ProductsField',
}
